module.exports = [{
      plugin: require('../node_modules/@emdgroup-liquid/gatsby-plugin-google-gtag/gatsby-browser.js'),
      options: {"plugins":[],"trackingIds":["G-DYTWZB4H4K"],"pluginConfig":{"head":true,"respectDNT":false,"consentKey":"gtag-consent"}},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
